import { NetzbetreiberDatenabfrage } from './netzbetreiber-datenabfrage';

export class Datenabfrage {
    public id: number;
    public bezeichnung: string;
    public referenzzeitraumEndverbraucherlast: Date;
    public referenzzeitraumErzeugerleistung: Date;
    public abgabefrist: Date;
    public aufteilungsschluesselCount: number;
    public zugeordneteNetzbetreiber: NetzbetreiberDatenabfrage[];
}
